import React from "react";

const PreviewTabs = ({
  tabs,
  view = "tabs",
  activeTabId,
  setActiveTabId,
  theme,
}) => {
  const dropdownStyle = {
    padding: "8px 12px",
    borderRadius: "4px",
    border: `1px solid ${theme?.borderColor || "#ccc"}`,
    minWidth: "200px",
    fontSize: "14px",
    background: theme?.background || "#ffffff",
    color: theme?.textColor || "#333333",
  };

  // Dropdown view
  if (view === "dropdown") {
    return (
      <div style={{ marginBottom: "15px" }}>
        <select
          value={activeTabId}
          onChange={(e) => setActiveTabId(e.target.value)}
          style={dropdownStyle}
        >
          {tabs.map((tab) => (
            <option key={tab.id} value={tab.id}>
              {tab.title || "Untitled Tab"}
            </option>
          ))}
        </select>
      </div>
    );
  }

  // Tab buttons view (default)
  return (
    <div className="preview-tabs">
      {tabs.map((tab) => {
        const isActive = tab.id === activeTabId;
        
        const buttonStyle = {
          padding: "10px 20px",
          border: `1px solid ${theme?.borderColor || "#d0d0d0"}`,
          background: isActive ? (theme?.activeBackground || "#2563eb") : (theme?.background || "#fff"),
          color: isActive ? (theme?.activeTextColor || "#ffffff") : (theme?.textColor || "#333333"),
          cursor: "pointer",
          borderRadius: "6px",
          fontSize: "14px",
          fontWeight: "500",
          transition: "all 0.2s",
        };

        return (
          <button
            key={tab.id}
            className="tab-btn"
            onClick={() => setActiveTabId(tab.id)}
            style={buttonStyle}
            onMouseEnter={(e) => {
              if (!isActive) {
                e.target.style.background = theme?.hoverBackground || "#f0f0f0";
              }
            }}
            onMouseLeave={(e) => {
              if (!isActive) {
                e.target.style.background = theme?.background || "#fff";
              }
            }}
          >
            {tab.title || "Untitled Tab"}
          </button>
        );
      })}
    </div>
  );
};

export default PreviewTabs;